import { datadogLogs } from '@datadog/browser-logs';

/** `key` and `email` are the same value so flags can target users by email. */
export const identifyLaunchDarklyUser = async (ldClient, user) => {
    const email = user.email?.toLowerCase();
    try {
        await ldClient.identify({ kind: 'user', key: email, email });
    } catch (error) {
        // LD keeps evaluating with the anonymous context, so a failure here should not block login.
        datadogLogs.logger.error('LaunchDarkly identify failed', { error });
    }
};
